import axiosInstance from '../plugin/axios';

interface DriverMypageResponse {
  vehicle: string;
  phone: string;
  registration: string;
  to_user_id: string;
}

interface CompanyMypageResponse {
  passid: string;
  name: string;
  charge: string;
  position: string;
  phone: string;
  address: string;
  registration: string;
}

interface PasswordChangeDTO {
  oldPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
}

interface PasswordChangeResponse {
  statusCode: number;
  message: string;
}

interface ChangePhoneDTO {
  phone: string;
}

interface ChangePhoneResponse {
  statusCode: number;
  message: string;
}

interface UploadResponse {
  statusCode: number;
  message: string;
  registration: string;
}

interface VehicleData {
  id: number;
  vehicle: string;
}

interface DriverAmountResponse {
  halfDay: number;
  fullDay: number;
  ryubei: number;
  cycle: number;
  freshWater: number;
  wasteWater: number;
  delay: number;
}

interface CompanyStandardTaskResponse {
  halfDay: string;
  fullDay: string;
  etcCondition: string;
  otCondition: string;
  cycleCondition: string;
  fuelSupport: boolean;
}

interface StandardTaskUpdateRequest {
  halfDay: string;
  fullDay: string;
  etcCondition: string;
  otCondition: string;
  cycleCondition: string;
  fuelSupport: boolean;
}

interface StandardTaskUpdateResponse {
  statusCode: number;
  message: string;
}

interface DriverAmountState {
  halfDay: number;
  fullDay: number;
  ryubei: number;
  cycle: number;
  freshWater: number;
  wasteWater: number;
  delay: number;
}

interface DriverAmountUpdateResponse {
  statusCode: number;
  message: string;
}

interface UpdateCompanyInfoRequest {
  charge: string;
  position: string;
}

interface UpdateCompanyInfoResponse {
  statusCode: number;
  message: string;
}

// 기사 회원 마이 페이지 조회 API 호출 함수
export const fetchDriverMypage = async (): Promise<DriverMypageResponse> => {
  try {
    const response = await axiosInstance.get<DriverMypageResponse>(
      '/api/mypage/driver',
    );
    return response.data;
  } catch (error) {
    console.error('마이페이지 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('마이페이지 데이터를 불러오는 데 실패했습니다.');
  }
};

// company 회원 마이 페이지 조회 API 호출 함수
export const fetchCompanyMypage = async (): Promise<CompanyMypageResponse> => {
  try {
    const response = await axiosInstance.get<CompanyMypageResponse>(
      '/api/mypage/company',
    );
    return response.data;
  } catch (error) {
    console.error('마이페이지 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('마이페이지 데이터를 불러오는 데 실패했습니다.');
  }
};

// 기사 비밀번호 변경
export const changeUserPassword = async (
  data: PasswordChangeDTO,
): Promise<PasswordChangeResponse> => {
  const response = await axiosInstance.put('/api/mypage/driver/password', data);
  return response.data;
};

// company 비밀번호 변경
export const changeCompanyPassword = async (
  data: PasswordChangeDTO,
): Promise<PasswordChangeResponse> => {
  const response = await axiosInstance.put(
    '/api/mypage/company/update/password',
    data,
  );
  return response.data;
};

// 핸드폰 번호 변경
export const changeUserPhone = async (
  data: ChangePhoneDTO,
): Promise<ChangePhoneResponse> => {
  const response = await axiosInstance.put(
    '/api/mypage/driver/change/phone',
    data,
  );
  return response.data;
};

// company 번호 변경
export const chargeCompanyPhone = async (
  data: ChangePhoneDTO,
): Promise<ChangePhoneResponse> => {
  const response = await axiosInstance.put(
    '/api/mypage/company/update/phone',
    data,
  );
  return response.data;
};

// 자동차 등록증
export const updateRegistration = async (
  registrationUrl: string,
): Promise<UploadResponse> => {
  const response = await axiosInstance.put<UploadResponse>(
    '/api/mypage/update/driver/registration',
    {
      registration: registrationUrl,
    },
  );
  return response.data;
};

// 사업자 등록증
export const companyUpdateRegistration = async (
  registrationUrl: string,
): Promise<UploadResponse> => {
  const response = await axiosInstance.put<UploadResponse>(
    '/api/mypage/update/company/registration',
    {
      registration: registrationUrl,
    },
  );

  return response.data;
};

// 위임 권한 설정
// 위임 권한 조회
export const fetchDelegationData = async (
  vehicle?: string,
): Promise<VehicleData[]> => {
  const response = await axiosInstance.get<VehicleData[]>(
    '/api/mypage/driver/entrust',
    {
      params: { vehicle: vehicle || '' },
    },
  );

  return response.data;
};

// 위임 설정
export const setDelegation = async (id: number) => {
  console.log(id);
  const response = await axiosInstance.post('/api/mypage/driver/entrust', {
    id,
  });
  return response.data;
};

// 위임 권한 취소
export const cancelDelegation = async (): Promise<{
  statusCode: number;
  message: string;
}> => {
  const response = await axiosInstance.delete('/api/mypage/driver/entrust');
  return response.data;
};

// company 정보 변경
export const updateCompanyInfo = async (
  data: UpdateCompanyInfoRequest,
): Promise<UpdateCompanyInfoResponse> => {
  try {
    const response = await axiosInstance.put<UpdateCompanyInfoResponse>(
      '/api/mypage/company/change/company',
      data,
    );
    return response.data;
  } catch (error) {
    console.error('기사 정보를 변경하는 ��� 실��했습니다.', error);
    throw new Error('기사 정보를 변경하는 ��� 실��했습니다.');
  }
};

// driver 기준 금액 호출
export const fetchDriverAmount = async (): Promise<DriverAmountResponse> => {
  try {
    const response = await axiosInstance.get<DriverAmountResponse>(
      '/api/mypage/driver/standardamount',
    );
    return response.data;
  } catch (error) {
    console.error('기준 금액 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('기준 금액 데이터를 불러오는 데 실패했습니다.');
  }
};

// company 작업 기준 호출
export const fetchStandardTask =
  async (): Promise<CompanyStandardTaskResponse> => {
    try {
      const response = await axiosInstance.get<CompanyStandardTaskResponse>(
        '/api/mypage/company/standardtask',
      );
      return response.data;
    } catch (error) {
      console.error('작업 기준 데이터를 불러오는 데 실패했습니다.', error);
      throw new Error('작업 기준 데이터를 불러오는 데 실패했습니다.');
    }
  };

// company 작업 기준 변경
export const updateStandardTask = async (
  data: StandardTaskUpdateRequest,
): Promise<StandardTaskUpdateResponse> => {
  try {
    const response = await axiosInstance.put<StandardTaskUpdateResponse>(
      '/api/mypage/company/update/standardtask',
      data,
    );
    return response.data;
  } catch (error) {
    console.error('작업 기준 업데이트 중 오류가 발생했습니다:', error);
    throw new Error('작업 기준 업데이트에 실패했습니다.');
  }
};

// 표준 금액 업데이트 함수
export const updateDriverAmount = async (
  data: DriverAmountState,
): Promise<DriverAmountUpdateResponse> => {
  try {
    const response = await axiosInstance.put(
      '/api/mypage/driver/standardamount',
      data,
    );
    //console.log('표준 금액이 성공적으로 업데이트되었습니다.');
    return response.data;
  } catch (error) {
    console.error('표준 금액 업데이트 중 오류가 발생했습니다:', error);
    throw new Error('표준 금액 업데이트 중 오류가 발생했습니다.');
  }
};
